module.exports = __webpack_public_path__ + "static/media/loader.eeafce9c.svg";